import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "error"]
  static values = {
    rules: Object
  }

  connect() {
    this.element.addEventListener("submit", this.validate.bind(this))

    this.fieldTargets.forEach(field => {
      field.addEventListener("blur", () => this.validateField(field))
      field.addEventListener("input", () => this.clearError(field))
    })
  }

  validate(event) {
    let isValid = true

    this.fieldTargets.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false
      }
    })

    if (!isValid) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  validateField(field) {
    const rules = this.rulesValue[field.name]
    if (!rules) return true

    const value = field.value.trim()
    let error = null

    // Required check
    if (rules.required && !value) {
      error = rules.required.message || "This field is required"
    }
    // Min length check
    else if (rules.minLength && value.length < rules.minLength.value) {
      error = rules.minLength.message || `Minimum ${rules.minLength.value} characters`
    }
    // Max length check
    else if (rules.maxLength && value.length > rules.maxLength.value) {
      error = rules.maxLength.message || `Maximum ${rules.maxLength.value} characters`
    }
    // Pattern/Regex check
    else if (rules.pattern && !new RegExp(rules.pattern.value).test(value)) {
      error = rules.pattern.message || "Invalid format"
    }
    // Email check
    else if (rules.email && !this.isValidEmail(value)) {
      error = rules.email.message || "Invalid email address"
    }
    // Min number check
    else if (rules.min && parseFloat(value) < parseFloat(rules.min.value)) {
      error = rules.min.message || `Minimum value is ${rules.min.value}`
    }
    // Max number check
    else if (rules.max && parseFloat(value) > parseFloat(rules.max.value)) {
      error = rules.max.message || `Maximum value is ${rules.max.value}`
    }

    if (error) {
      this.showError(field, error)
      return false
    } else {
      this.clearError(field)
      return true
    }
  }

  showError(field, message) {
    // Add error styling to field
    field.classList.add("border-destructive", "bg-destructive/5")
    field.classList.remove("border-input", "border-green-600")

    // Show error message
    const errorElement = this.errorTargets.find(el => el.dataset.field === field.name)
    if (errorElement) {
      errorElement.textContent = message
      errorElement.classList.remove("hidden")
    }
  }

  clearError(field) {
    // Remove error styling
    field.classList.remove("border-destructive", "bg-destructive/5")
    field.classList.add("border-input")

    // Hide error message
    const errorElement = this.errorTargets.find(el => el.dataset.field === field.name)
    if (errorElement) {
      errorElement.textContent = ""
      errorElement.classList.add("hidden")
    }
  }

  isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(email)
  }
}
